import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import RecipientService from '../../../services/RecipientService';
import AuthService from '../../../services/AuthService';
import BankService from '../../../services/BankService';
import Flags from "react-world-flags";

const RecipientFormModal = ({ show, handleClose, onDataReload }) => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [city, setCity] = useState('');
    const [country, setCountry] = useState('Cameroun');
    const [email, setEmail] = useState('');
    const [username, setUsername] = useState('');
    const [bankAccountInfos, setBankAccountInfos] = useState([]);
    const [walletAccountInfos, setWalletAccountInfos] = useState([]);
    const [banks, setBanks] = useState([]);
    const walletTypes = ["ORANGE_MONEY", "MTN_MOBILE_MONEY", "WAVE"];
    const countries = [
        { name: "Cameroun", code: "CM" },
        { name: "Bénin", code: "BJ" },
        { name: "Burkina Faso", code: "BF" },
        { name: "Côte d'Ivoire", code: "CI" },
        { name: "Sénégal", code: "SN" }
    ];
    const countryToCodes = {
        "Cameroun": "237",
        "Bénin": "229",
        "Burkina Faso": "226",
        "Côte d'Ivoire": "225",
        "Sénégal": "221"
    };
    const [touchedFields, setTouchedFields] = useState({
        firstName: false,
        lastName: false,
        branchName: false,
        city: false,
        country: false,
        email: false,
        bankAccountInfos: [],
        walletAccountInfos: []
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        const currentUser = AuthService.getCurrentUser();
        if (currentUser) {
            setUsername(currentUser.username);
        }
    }, []);

    useEffect(() => {
        const fetchBanks = async () => {
            try {
                const banksData = await BankService.getAllBanks();
                const cameroonBanks = banksData.filter(bank => bank.country === "Cameroun");
                setBanks(cameroonBanks);
            } catch (error) {
                console.error('Error fetching banks:', error.message || error);
            }
        };
        fetchBanks();
    }, []);

    useEffect(() => {
        setBankAccountInfos(bankAccountInfos.map(info => ({
            ...info,
            city: city,
            country: country
        })));
        setWalletAccountInfos(walletAccountInfos.map(info => ({
            ...info,
            city: city,
            country: country,
            phoneNumber: ''
        })));
    }, [city, country]);

    const handleAddBankAccountInfo = () => {
        setBankAccountInfos([...bankAccountInfos, {
            accountName: '',
            branchName: '',
            branchNumber: '',
            accountNumber: '',
            accountKey: '',
            city: city,
            address: '',
            country: country
        }]);
        setTouchedFields({
            ...touchedFields,
            bankAccountInfos: [...touchedFields.bankAccountInfos, {
                accountName: false,
                branchName: false,
                branchNumber: false,
                accountNumber: false,
                accountKey: false,
                city: false,
                address: false,
                country: false
            }]
        });
    };

    const handleAddWalletAccountInfo = () => {
        setWalletAccountInfos([...walletAccountInfos, {
            phoneNumber: '',
            accountName: '',
            walletType: '',
            city: city,
            address: '',
            country: country
        }]);
        setTouchedFields({
            ...touchedFields,
            walletAccountInfos: [...touchedFields.walletAccountInfos, {
                phoneNumber: false,
                accountName: false,
                walletType: false,
                city: false,
                address: false,
                country: false
            }]
        });
    };

    const handleBankAccountInfoChange = (index, field, value) => {
        const updatedBankAccountInfos = [...bankAccountInfos];
        updatedBankAccountInfos[index][field] = value;
        setBankAccountInfos(updatedBankAccountInfos);
        const updatedTouchedFields = [...touchedFields.bankAccountInfos];
        updatedTouchedFields[index] = {
            ...updatedTouchedFields[index],
            [field]: true
        };
        setTouchedFields({
            ...touchedFields,
            bankAccountInfos: updatedTouchedFields
        });
    };

    const handleWalletAccountInfoChange = (index, field, value) => {
        const updatedWalletAccountInfos = [...walletAccountInfos];
        updatedWalletAccountInfos[index][field] = value;
        setWalletAccountInfos(updatedWalletAccountInfos);
        const updatedTouchedFields = [...touchedFields.walletAccountInfos];
        updatedTouchedFields[index] = {
            ...updatedTouchedFields[index],
            [field]: true
        };
        setTouchedFields({
            ...touchedFields,
            walletAccountInfos: updatedTouchedFields
        });
    };

    const handleRemoveBankAccountInfo = (index) => {
        const updatedBankAccountInfos = [...bankAccountInfos];
        updatedBankAccountInfos.splice(index, 1);
        setBankAccountInfos(updatedBankAccountInfos);
        const updatedTouchedFields = [...touchedFields.bankAccountInfos];
        updatedTouchedFields.splice(index, 1);
        setTouchedFields({
            ...touchedFields,
            bankAccountInfos: updatedTouchedFields
        });
    };

    const handleRemoveWalletAccountInfo = (index) => {
        const updatedWalletAccountInfos = [...walletAccountInfos];
        updatedWalletAccountInfos.splice(index, 1);
        setWalletAccountInfos(updatedWalletAccountInfos);
        const updatedTouchedFields = [...touchedFields.walletAccountInfos];
        updatedTouchedFields.splice(index, 1);
        setTouchedFields({
            ...touchedFields,
            walletAccountInfos: updatedTouchedFields
        });
    };

    const handleBlur = (field) => {
        setTouchedFields({
            ...touchedFields,
            [field]: true
        });
    };

    const validateField = (field, value) => {
        switch (field) {
            case 'firstName':
            case 'lastName':
            case 'city':
            case 'address':
            case 'accountName': // Champ obligatoire pour les comptes bancaires et wallets
                return value.trim() !== '';
            case 'email':
                return value === '' || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
            case 'branchNumber':
                return /^\d{5}$/.test(value);
            case 'branchName':
                return value.trim() !== '';
            case 'accountNumber':
                return /^\d{11}$/.test(value);
            case 'accountKey':
                return /^\d{2}$/.test(value);
            case 'phoneNumber':
                return /^\d{1,15}$/.test(value);
            case 'walletType':
                return walletTypes.includes(value);
            case 'country':
                return countries.map(c => c.name).includes(value);
            default:
                return true;
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setTouchedFields({
            firstName: true,
            lastName: true,
            city: true,
            country: true,
            email: true,
            bankAccountInfos: bankAccountInfos.map(() => ({
                accountName: true,
                branchName: true,
                branchNumber: true,
                accountNumber: true,
                accountKey: true,
                city: true,
                address: true,
                country: true
            })),
            walletAccountInfos: walletAccountInfos.map(() => ({
                phoneNumber: true,
                accountName: true,
                walletType: true,
                city: true,
                address: true,
                country: true
            }))
        });

        const isFirstNameValid = validateField('firstName', firstName);
        const isLastNameValid = validateField('lastName', lastName);
        const isCityValid = validateField('city', city);
        const isCountryValid = validateField('country', country);
        const isEmailValid = validateField('email', email);

        const areBankAccountInfosValid = bankAccountInfos.every(info =>
            validateField('accountName', info.accountName) &&
            validateField('branchName', info.branchName) &&
            validateField('branchNumber', info.branchNumber) &&
            validateField('accountNumber', info.accountNumber) &&
            validateField('accountKey', info.accountKey) &&
            validateField('city', info.city) &&
            validateField('address', info.address)
        );

        const areWalletAccountInfosValid = walletAccountInfos.every(info =>
            validateField('phoneNumber', info.phoneNumber) &&
            validateField('accountName', info.accountName) &&
            validateField('walletType', info.walletType) &&
            validateField('city', info.city) &&
            validateField('address', info.address)
        );

        if (!isFirstNameValid || !isLastNameValid || !isCityValid ||
            !isCountryValid || !isEmailValid ||
            !areBankAccountInfosValid || !areWalletAccountInfosValid) {
            toast.error('Veuillez remplir correctement tous les champs requis.');
            return;
        }

        setIsSubmitting(true);
        setErrorMessage('');
        const formattedWalletAccountInfos = walletAccountInfos.map(info => {
            const countryCode = countryToCodes[country] ? `+${countryToCodes[country]}` : '';
            return {
                ...info,
                phoneNumber: countryCode + info.phoneNumber
            };
        });

        const formData = {
            firstName,
            lastName,
            city,
            country,
            email,
            username,
            recipientAccountInfo: {
                bankAccountInfos,
                walletAccountInfos: formattedWalletAccountInfos
            }
        };

        try {
            await RecipientService.createRecipient(formData);
            toast.success('Contact enregistré avec succès!');
            handleClose();
            resetForm();
            onDataReload();
        } catch (error) {
            toast.error('Erreur lors de l\'enregistrement du contact.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const resetForm = () => {
        setFirstName('');
        setLastName('');
        setCity('');
        setCountry('Cameroun');
        setEmail('');
        setBankAccountInfos([]);
        setWalletAccountInfos([]);
        setTouchedFields({
            firstName: false,
            lastName: false,
            city: false,
            country: false,
            email: false,
            bankAccountInfos: [],
            walletAccountInfos: []
        });
        setErrorMessage('');
    };

    const isAddBankAccountButtonDisabled = country !== 'Cameroun';

    return (
        <Modal size="lg" show={show} onHide={() => { handleClose(); resetForm(); }}>
            <Modal.Header closeButton>
                <Modal.Title>Ajouter un contact</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    {errorMessage && (
                        <div className="alert alert-danger d-flex justify-content-between align-items-center" role="alert">
                            {errorMessage}
                            <Button variant="outline-danger" size="sm" onClick={() => setErrorMessage('')}>
                                Fermer
                            </Button>
                        </div>
                    )}
                    <Form.Group controlId="lastName" className="form-floating mt-3">
                        <Form.Control
                            type="text"
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                            onBlur={() => handleBlur('lastName')}
                            className={touchedFields.lastName && validateField('lastName', lastName) ? 'is-valid' : (touchedFields.lastName ? 'is-invalid' : '')}
                            autoComplete="off"
                        />
                        <Form.Label>Nom</Form.Label>
                        <Form.Control.Feedback type="invalid">
                            Veuillez entrer un nom.
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="firstName" className="form-floating mt-3">
                        <Form.Control
                            type="text"
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                            onBlur={() => handleBlur('firstName')}
                            className={touchedFields.firstName && validateField('firstName', firstName) ? 'is-valid' : (touchedFields.firstName ? 'is-invalid' : '')}
                            autoComplete="off"
                        />
                        <Form.Label>Prénom</Form.Label>
                        <Form.Control.Feedback type="invalid">
                            Veuillez entrer un prénom.
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="email" className="form-floating mt-3">
                        <Form.Control
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            onBlur={() => handleBlur('email')}
                            className={touchedFields.email && validateField('email', email) ? 'is-valid' : (touchedFields.email && email !== '' ? 'is-invalid' : '')}
                            autoComplete="off"
                        />
                        <Form.Label>Email (optionnel)</Form.Label>
                        <Form.Control.Feedback type="invalid">
                            Veuillez entrer un email valide.
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="country" className="form-floating mt-3">
                        <Form.Select
                            value={country}
                            onChange={(e) => {
                                setCountry(e.target.value);
                                setBankAccountInfos([]);
                                setWalletAccountInfos([]);
                            }}
                            onBlur={() => handleBlur('country')}
                            className={touchedFields.country && validateField('country', country) ? 'is-valid' : (touchedFields.country ? 'is-invalid' : '')}
                            autoComplete="off"
                        >
                            <option value="">Sélectionner un pays</option>
                            {countries.map((c, i) => (
                                <option key={i} value={c.name}>
                                    {c.name}
                                </option>
                            ))}
                        </Form.Select>
                        <Form.Label>Pays</Form.Label>
                        <Form.Control.Feedback type="invalid">
                            Veuillez sélectionner un pays.
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="city" className="form-floating mt-3">
                        <Form.Control
                            type="text"
                            value={city}
                            onChange={(e) => setCity(e.target.value)}
                            onBlur={() => handleBlur('city')}
                            className={touchedFields.city && validateField('city', city) ? 'is-valid' : (touchedFields.city ? 'is-invalid' : '')}
                            autoComplete="off"
                        />
                        <Form.Label>Ville</Form.Label>
                        <Form.Control.Feedback type="invalid">
                            Veuillez entrer une ville.
                        </Form.Control.Feedback>
                    </Form.Group>
                    {/* Compte Bancaire */}
                    <div className="mt-4 mb-4 d-flex align-items-center">
                        <div className="flex-grow-1 border-bottom"></div>
                        <h5 className="mx-3 mb-0">Informations de Compte Bancaire</h5>
                        <div className="flex-grow-1 border-bottom"></div>
                    </div>
                    {bankAccountInfos.map((info, index) => (
                        <div key={index} className="mt-3 border p-3 rounded">
                            <Button variant="danger" onClick={() => handleRemoveBankAccountInfo(index)}>
                                Supprimer
                            </Button>
                            <Form.Group controlId={`accountName-${index}`} className="form-floating mt-3">
                                <Form.Control
                                    type="text"
                                    value={info.accountName}
                                    onChange={(e) => handleBankAccountInfoChange(index, 'accountName', e.target.value)}
                                    onBlur={() => handleBlur(`bankAccountInfos[${index}].accountName`)}
                                    className={touchedFields.bankAccountInfos[index]?.accountName && validateField('accountName', info.accountName) ? 'is-valid' : (touchedFields.bankAccountInfos[index]?.accountName ? 'is-invalid' : '')}
                                    autoComplete="off"
                                />
                                <Form.Label>Intitulé du compte</Form.Label>
                                <Form.Control.Feedback type="invalid">
                                    Veuillez entrer un intitulé de compte.
                                </Form.Control.Feedback>
                            </Form.Group>





                            <Form.Group controlId={`branchName-${index}`} className="form-floating mt-3">
                                <Form.Select
                                    value={info.branchName}
                                    onChange={(e) => handleBankAccountInfoChange(index, 'branchName', e.target.value)}
                                    onBlur={() => handleBlur(`bankAccountInfos[${index}].branchName`)}
                                    className={touchedFields.bankAccountInfos[index]?.branchName && validateField('branchName', info.branchName) ? 'is-valid' : (touchedFields.bankAccountInfos[index]?.branchName ? 'is-invalid' : '')}
                                    autoComplete="off"
                                >
                                    <option value="">Sélectionner une banque</option>
                                    {banks.map((bank, i) => (
                                        <option key={i} value={bank.bankName}>
                                            {bank.bankName}
                                        </option>
                                    ))}
                                </Form.Select>
                                <Form.Label>Nom de l'agence</Form.Label>
                                <Form.Control.Feedback type="invalid">
                                    Veuillez sélectionner une banque.
                                </Form.Control.Feedback>
                            </Form.Group>


                            <Form.Group controlId={`branchNumber-${index}`} className="form-floating mt-3">
                                <Form.Control
                                    type="text"
                                    value={info.branchNumber}
                                    onChange={(e) => handleBankAccountInfoChange(index, 'branchNumber', e.target.value)}
                                    onBlur={() => handleBlur(`bankAccountInfos[${index}].branchNumber`)}
                                    pattern="\d{5}"
                                    className={touchedFields.bankAccountInfos[index]?.branchNumber && validateField('branchNumber', info.branchNumber) ? 'is-valid' : (touchedFields.bankAccountInfos[index]?.branchNumber ? 'is-invalid' : '')}
                                    autoComplete="off"
                                />
                                <Form.Label>Code agence</Form.Label>
                                <Form.Control.Feedback type="invalid">
                                    Veuillez entrer un code d'agence valide (5 chiffres).
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group controlId={`accountNumber-${index}`} className="form-floating mt-3">
                                <Form.Control
                                    type="text"
                                    value={info.accountNumber}
                                    onChange={(e) => handleBankAccountInfoChange(index, 'accountNumber', e.target.value)}
                                    onBlur={() => handleBlur(`bankAccountInfos[${index}].accountNumber`)}
                                    pattern="\d{11}"
                                    className={touchedFields.bankAccountInfos[index]?.accountNumber && validateField('accountNumber', info.accountNumber) ? 'is-valid' : (touchedFields.bankAccountInfos[index]?.accountNumber ? 'is-invalid' : '')}
                                    autoComplete="off"
                                />
                                <Form.Label>Numéro de Compte</Form.Label>
                                <Form.Control.Feedback type="invalid">
                                    Veuillez entrer un numéro de compte (11 chiffres).
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group controlId={`accountKey-${index}`} className="form-floating mt-3">
                                <Form.Control
                                    type="text"
                                    value={info.accountKey}
                                    onChange={(e) => handleBankAccountInfoChange(index, 'accountKey', e.target.value)}
                                    onBlur={() => handleBlur(`bankAccountInfos[${index}].accountKey`)}
                                    pattern="\d{2}"
                                    className={touchedFields.bankAccountInfos[index]?.accountKey && validateField('accountKey', info.accountKey) ? 'is-valid' : (touchedFields.bankAccountInfos[index]?.accountKey ? 'is-invalid' : '')}
                                    autoComplete="off"
                                />
                                <Form.Label>Clé de Compte</Form.Label>
                                <Form.Control.Feedback type="invalid">
                                    Veuillez entrer une clé de compte (2 chiffres).
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group controlId={`address-${index}`} className="form-floating mt-3">
                                <Form.Control
                                    type="text"
                                    value={info.address}
                                    onChange={(e) => handleBankAccountInfoChange(index, 'address', e.target.value)}
                                    onBlur={() => handleBlur(`bankAccountInfos[${index}].address`)}
                                    className={touchedFields.bankAccountInfos[index]?.address && validateField('address', info.address) ? 'is-valid' : (touchedFields.bankAccountInfos[index]?.address ? 'is-invalid' : '')}
                                    autoComplete="off"
                                />
                                <Form.Label>Adresse (Quartier)</Form.Label>
                                <Form.Control.Feedback type="invalid">
                                    Veuillez entrer une adresse.
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group controlId={`country-${index}`} className="form-floating mt-3">
                                <Form.Control
                                    type="text"
                                    value={info.country}
                                    disabled
                                    className="form-control"
                                    autoComplete="off"
                                />
                                <Form.Label>Pays</Form.Label>
                            </Form.Group>

                            <Form.Group controlId={`city-${index}`} className="form-floating mt-3">
                                <Form.Control
                                    type="text"
                                    value={info.city}
                                    disabled
                                    className="form-control"
                                    autoComplete="off"
                                />
                                <Form.Label>Ville</Form.Label>
                            </Form.Group>
                        </div>
                    ))}



                    <div className="mt-3 mb-5 d-flex justify-content-center align-items-center flex-column">
                        <div className="d-flex flex-column align-items-center">
                            <p style={{
                                fontStyle: 'italic',
                                marginBottom: '10px',
                                color: '#007bff'
                            }}>
                                Cliquer sur le bouton ci-dessous pour ajouter un compte bancaire
                            </p>

                            <Button
                                variant="outline-primary"
                                onClick={handleAddBankAccountInfo}
                                disabled={isAddBankAccountButtonDisabled || isSubmitting}
                                style={{
                                    width: '60px',
                                    height: '60px',
                                    borderRadius: '50%',
                                    border: '2px solid #007bff',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '30px',
                                    fontWeight: 'bold',
                                    padding: '0',
                                    backgroundColor: 'transparent'
                                }}
                                className="d-flex justify-content-center align-items-center"
                            >
                                +
                            </Button>
                        </div>
                    </div>





                    {/* Compte Wallet */}
                    <div className="mt-4 mb-4 d-flex align-items-center">
                        <div className="flex-grow-1 border-bottom"></div>
                        <h5 className="mx-3 mb-0">Informations de Compte Wallet</h5>
                        <div className="flex-grow-1 border-bottom"></div>
                    </div>
                    {walletAccountInfos.map((info, index) => (
                        <div key={index} className="mt-3 border p-3 rounded">
                            <Button variant="danger" onClick={() => handleRemoveWalletAccountInfo(index)}>
                                Supprimer
                            </Button>
                            <Form.Group controlId={`walletType-${index}`} className="form-floating mt-3">
                                <Form.Select
                                    value={info.walletType}
                                    onChange={(e) => handleWalletAccountInfoChange(index, 'walletType', e.target.value)}
                                    onBlur={() => handleBlur(`walletAccountInfos[${index}].walletType`)}
                                    className={touchedFields.walletAccountInfos[index]?.walletType && validateField('walletType', info.walletType) ? 'is-valid' : (touchedFields.walletAccountInfos[index]?.walletType ? 'is-invalid' : '')}
                                    autoComplete="off"
                                >
                                    <option value="">Sélectionner un type de wallet</option>
                                    {walletTypes.map((type, i) => (
                                        <option key={i} value={type}>
                                            {type}
                                        </option>
                                    ))}
                                </Form.Select>
                                <Form.Label>Type de Wallet</Form.Label>
                                <Form.Control.Feedback type="invalid">
                                    Veuillez sélectionner un type de wallet.
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group controlId={`phoneNumber-${index}`} className="form-floating mt-3">
                                <Form.Label>Numéro de téléphone</Form.Label> <br/><br/>
                                <div className="d-flex align-items-center">
                                    <div className="d-flex align-items-center" style={{ marginRight: '10px' }}>
                                        <Flags
                                            code={countries.find(c => c.name === country)?.code || "CM"}
                                            style={{ width: "20px", marginRight: "5px" }}
                                        />
                                        <span>+{countryToCodes[country] || "237"}</span>
                                    </div>
                                    <Form.Control
                                        type="text"
                                        value={info.phoneNumber}
                                        onChange={(e) => handleWalletAccountInfoChange(index, 'phoneNumber', e.target.value)}
                                        onBlur={() => handleBlur(`walletAccountInfos[${index}].phoneNumber`)}
                                        className={touchedFields.walletAccountInfos[index]?.phoneNumber && validateField('phoneNumber', info.phoneNumber) ? 'is-valid' : (touchedFields.walletAccountInfos[index]?.phoneNumber ? 'is-invalid' : '')}
                                        autoComplete="off"
                                        placeholder="Saisissez le numéro"
                                    />
                                </div>
                                <Form.Control.Feedback type="invalid">
                                    Veuillez entrer un numéro de téléphone valide (uniquement des chiffres, max 15 chiffres).
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group controlId={`accountName-${index}`} className="form-floating mt-3">
                                <Form.Control
                                    type="text"
                                    value={info.accountName}
                                    onChange={(e) => handleWalletAccountInfoChange(index, 'accountName', e.target.value)}
                                    onBlur={() => handleBlur(`walletAccountInfos[${index}].accountName`)}
                                    className={touchedFields.walletAccountInfos[index]?.accountName && validateField('accountName', info.accountName) ? 'is-valid' : (touchedFields.walletAccountInfos[index]?.accountName ? 'is-invalid' : '')}
                                    autoComplete="off"
                                />
                                <Form.Label>Nom du Compte Wallet</Form.Label>
                                <Form.Control.Feedback type="invalid">
                                    Veuillez entrer un nom de compte.
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group controlId={`address-${index}`} className="form-floating mt-3">
                                <Form.Control
                                    type="text"
                                    value={info.address}
                                    onChange={(e) => handleWalletAccountInfoChange(index, 'address', e.target.value)}
                                    onBlur={() => handleBlur(`walletAccountInfos[${index}].address`)}
                                    className={touchedFields.walletAccountInfos[index]?.address && validateField('address', info.address) ? 'is-valid' : (touchedFields.walletAccountInfos[index]?.address ? 'is-invalid' : '')}
                                    autoComplete="off"
                                />
                                <Form.Label>Adresse (Quartier)</Form.Label>
                                <Form.Control.Feedback type="invalid">
                                    Veuillez entrer une adresse.
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group controlId={`country-${index}`} className="form-floating mt-3">
                                <Form.Control
                                    type="text"
                                    value={info.country}
                                    disabled
                                    className="form-control"
                                    autoComplete="off"
                                />
                                <Form.Label>Pays</Form.Label>
                            </Form.Group>

                            <Form.Group controlId={`city-${index}`} className="form-floating mt-3">
                                <Form.Control
                                    type="text"
                                    value={info.city}
                                    disabled
                                    className="form-control"
                                    autoComplete="off"
                                />
                                <Form.Label>Ville</Form.Label>
                            </Form.Group>
                        </div>
                    ))}


                    <div className="mt-3 mb-5 d-flex justify-content-center align-items-center flex-column">
                        <div className="d-flex flex-column align-items-center">
                            <p style={{
                                fontStyle: 'italic',
                                marginBottom: '10px',
                                color: '#007bff'
                            }}>
                                Cliquer sur le bouton ci-dessous pour ajouter un compte wallet
                            </p>

                            <Button
                                variant="outline-primary"
                                onClick={handleAddWalletAccountInfo}
                                disabled={isSubmitting}
                                style={{
                                    width: '60px',
                                    height: '60px',
                                    borderRadius: '50%',
                                    border: '2px solid #007bff',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '30px',
                                    fontWeight: 'bold',
                                    padding: '0',
                                    backgroundColor: 'transparent'
                                }}
                                className="d-flex justify-content-center align-items-center"
                            >
                                +
                            </Button>
                        </div>
                    </div>


                    <Modal.Footer className="d-flex justify-content-end gap-2" style={{paddingBottom: '80px' }}>
                        <Button variant="secondary" onClick={() => { handleClose(); resetForm(); }} disabled={isSubmitting}>
                            Annuler
                        </Button>
                        <Button variant="primary" type="submit" disabled={isSubmitting}>
                            {isSubmitting ? 'Chargement...' : 'Sauvegarder'}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default RecipientFormModal;
